export default __webpack_public_path__ + "static/media/ic_github.e56314a4.svg";